import {
  featureOperations,
  Features,
  type FeatureContext,
} from '@ardoq/features';
import {
  permissionsOperations,
  type PermissionContext,
} from '@ardoq/access-control';

type CanSaveViewpointAsWidgetArgs = {
  permissionContext: PermissionContext;
  featureContext: FeatureContext;
};

export const getCanSaveViewpointAsWidget = ({
  permissionContext,
  featureContext,
}: CanSaveViewpointAsWidgetArgs): boolean =>
  permissionsOperations.hasAdminRole(permissionContext) &&
  featureOperations.hasFeature(
    featureContext,
    Features.GROWTH_TMP_DASHBOARD_SAVE_BUBBLE_CHART_WIDGET
  );
